import Company from '@/models/Company'

export default {
  namespaced: true,
  state: {
    selected: null
  },

  mutations: {
    setSelectedCompany(state, payload) {
      state.selected = payload
    }
  },

  actions: {
    async getSelectedCompany({ commit }, id) {
      const company = await Company.$find(id)
      commit('setSelectedCompany', company)
    },
    async getCompanies() {
      const companies = await Company.custom('companies').get()

      return companies.data
    }
  }
}
